// extracted by mini-css-extract-plugin
export var bodySections = "_4p-8";
export var gray = "_4p-7";
export var green = "_4p-4";
export var iconContainer = "_4p-9";
export var iconWidgetContainer = "_4p-1";
export var phoneIcon = "_4p-2";
export var red = "_4p-5";
export var statusDot = "_4p-3";
export var widgetContainer = "_4p-0";
export var yellow = "_4p-6";